import "./FileFullPreview.scss";
import { baseUrl } from "../../../config";

export default {
  props: {
    file: Object,
  },

  methods: {
    createDownloadLink() {
      let downloadLink = `${baseUrl}/download?file=${this.file.id}`;

      downloadLink += `&company=${this.$store.state.company}`;
      downloadLink += `&myspace=${this.file.myspace}`;

      if (this.$store.state.user) {
        downloadLink += `&key=${this.$store.state.user.key}`;
      }

      return downloadLink;
    },
  },
};
